import type { Messages } from '../catalogue.en'

/**
 * The Control Center's Connectors section. Composed into the public
 * catalogue by `catalogue.ru.ts`; nothing imports this module directly.
 */
export const controlCenterConnectors: Partial<Messages> = {
  "connectors.title": "Каналы доставки сообщений",
  'connectors.subtitle':
    'Коннекторы электронной почты, Telegram и WhatsApp, через которые эта установка отправляет сообщения: их назначение, состояние и статус учётных данных. Учётные данные хранятся только для записи и никогда не показываются.',
  'connectors.loading': 'Загрузка коннекторов',
  'connectors.loadFailed': 'Не удалось загрузить коннекторы',
  'connectors.forbidden': 'Вам не разрешено читать коннекторы',
  'connectors.unavailable': 'Коннекторы сейчас недоступны',
  'connectors.tableLabel': 'Реестр коннекторов',
  'connectors.empty': 'Коннекторов нет',
  'connectors.emptyDetail': 'Коннекторы, зарегистрированные в этой установке, появятся здесь.',
  'connectors.noMatches': 'Нет коннекторов, соответствующих фильтрам',
  'connectors.noMatchesDetail': 'Расширьте или очистите фильтры столбцов, чтобы вернуться к полному реестру.',
  'connectors.column.identity': 'Идентичность',
  'connectors.column.channel': 'Канал',
  'connectors.column.provider': 'Провайдер',
  'connectors.column.purpose': 'Назначение',
  'connectors.column.audience': 'Аудитория',
  'connectors.column.lifecycle': 'Состояние',
  'connectors.column.credentials': 'Учётные данные',
  'connectors.column.migration': 'Миграция',
  'connectors.column.updated': 'Последнее изменение',
  'connectors.actions': 'Действия',
  'connectors.editNamed': 'Изменить {name}',
  'connectors.openNamed': 'Открыть {name}',
  'connectors.unrecognized': '{value} (не распознано)',
  'connectors.identity.unresolved': 'Идентичность не определена',

  'connectors.channel.email': 'Электронная почта',
  'connectors.channel.telegram': 'Telegram',
  'connectors.channel.whatsapp': 'WhatsApp',
  'connectors.provider.smtp': 'SMTP',
  'connectors.provider.telegram_bot_api': 'Telegram Bot API',
  'connectors.provider.twilio_whatsapp': 'Twilio WhatsApp',
  'connectors.purpose.transactional_email': 'Транзакционная почта',
  'connectors.purpose.staff_communications': 'Общение с персоналом',
  'connectors.purpose.patient_communications': 'Общение с пациентами',
  'connectors.purpose.legacy_mixed': 'Устаревшее: персонал и пациенты вместе',
  'connectors.purpose.migration_unresolved': 'Миграция не завершена',
  'connectors.audience.staff': 'Персонал',
  'connectors.audience.patient': 'Пациенты',
  'connectors.audience.none': 'Не задана',
  'connectors.lifecycle.enabled': 'Включён',
  'connectors.lifecycle.disabled': 'Выключен',
  'connectors.credentials.configured': 'Настроены',
  'connectors.credentials.not_configured': 'Не настроены',
  'connectors.credentials.unresolved': 'Не определены',
  'connectors.migration.pending': 'Ожидает',
  'connectors.migration.key_unavailable': 'Ключ недоступен',
  'connectors.migration.invalid_envelope': 'Повреждённый конверт',
  'connectors.migration.identity_unresolved': 'Идентичность не определена',
  'connectors.migration.ownership_unresolved': 'Владелец не определён',
  'connectors.migration.legacy_purpose_unresolved': 'Устаревшее назначение не разрешено',
  'connectors.migration.resolved': 'Завершена',
  'connectors.migration.cleared': 'Очищена',

  'connectors.detailLoading': 'Загрузка коннектора',
  'connectors.facts': 'Коннектор',
  'connectors.fact.channel': 'Канал',
  'connectors.fact.provider': 'Провайдер',
  'connectors.fact.purpose': 'Назначение',
  'connectors.fact.audience': 'Аудитория',
  'connectors.fact.lifecycle': 'Состояние',
  'connectors.fact.credentials': 'Учётные данные',
  'connectors.fact.migration': 'Миграция',
  'connectors.fact.botUsername': 'Бот',
  'connectors.fact.botUserId': 'Идентификатор бота',
  'connectors.fact.smtpHost': 'Сервер',
  'connectors.fact.smtpPort': 'Порт',
  'connectors.fact.smtpServerName': 'Имя сервера TLS',
  'connectors.fact.smtpTlsMode': 'Режим TLS',
  'connectors.fact.fromAddress': 'Адрес отправителя',
  'connectors.fact.fromName': 'Имя отправителя',
  'connectors.fact.twilioAccountPreview': 'Идентификатор аккаунта',
  'connectors.fact.whatsappFromPreview': 'Отправитель WhatsApp',
  'connectors.fact.created': 'Создан',
  'connectors.fact.updated': 'Последнее изменение',
  'connectors.readOnly': 'Только чтение',
  'connectors.readOnlyNote': 'Вы можете читать состояние коннектора, но не изменять его.',
  'connectors.secretsNote': 'Сохранённые учётные данные никогда не показываются. Оставьте их закрытыми, чтобы сохранить как есть.',
  'connectors.metadata.title': 'Назначение и состояние',
  'connectors.purpose': 'Назначение',
  'connectors.lifecycle': 'Состояние',
  'connectors.notConfiguredHint': 'Сохраните учётные данные, прежде чем включать коннектор.',
  'connectors.save': 'Сохранить коннектор',
  'connectors.saving': 'Сохранение',
  'connectors.saved': 'Коннектор сохранён',
  'connectors.reload': 'Перезагрузить коннектор',
  'connectors.reloaded': 'Перезагружено с сервера. Проверьте изменения и сохраните снова.',
  'connectors.reloadFailed': 'Не удалось перезагрузить коннектор.',
  'connectors.unsavedIntent': 'Форма коннектора \u2014 данные, которые не были сохранены',
  'connectors.credentials.title': 'Учётные данные',
  'connectors.credentials.replace': 'Заменить учётные данные',
  'connectors.credentials.keep': 'Оставить текущие учётные данные',
  'connectors.credentials.rotate': 'Сохранить новые учётные данные',
  'connectors.credentials.rotating': 'Проверка и сохранение',
  'connectors.credentials.rotated': 'Учётные данные заменены',
  'connectors.credentials.clear': 'Удалить учётные данные',
  'connectors.credentials.clearing': 'Удаление',
  'connectors.credentials.cleared': 'Учётные данные удалены',
  'connectors.credentials.clearTitle': 'Удалить сохранённые учётные данные?',
  'connectors.credentials.clearDescription':
    'Коннектор будет выключен, а его учётные данные стёрты. Его идентичность, назначение и история сохраняются; новые учётные данные можно сохранить позже.',
  'connectors.credentials.clearConfirm': 'Удалить',
  'connectors.cancel': 'Отмена',
  'connectors.legacyNote':
    'Этот бот перенесён из прежней настройки клиники и по-прежнему обслуживает персонал и пациентов вместе. Выберите одно назначение, чтобы разрешить его; вторая аудитория освободится для другого бота.',
  'connectors.unresolvedNote':
    'Эта запись сохраняет Telegram-бота, учётные данные которого не удалось перенести. Его назначение и учётные данные здесь изменить нельзя; удалите учётные данные, чтобы вывести запись из использования.',

  'connectors.createTitle': 'Новый коннектор',
  'connectors.create': 'Создать коннектор',
  'connectors.creating': 'Проверка и создание',
  'connectors.createNote': 'Новый коннектор создаётся выключенным. Включите его после сохранения учётных данных.',
  'connectors.providerKind': 'Провайдер',
  'connectors.field.smtpHost': 'Сервер SMTP',
  'connectors.field.smtpPort': 'Порт',
  'connectors.field.smtpServerName': 'Имя сервера TLS',
  'connectors.field.smtpTlsMode': 'Режим TLS',
  'connectors.field.tls.starttls': 'STARTTLS',
  'connectors.field.tls.tls': 'TLS',
  'connectors.field.fromAddress': 'Адрес отправителя',
  'connectors.field.fromName': 'Имя отправителя',
  'connectors.field.smtpUsername': 'Логин',
  'connectors.field.smtpPassword': 'Пароль',
  'connectors.field.telegramBotToken': 'Токен бота',
  'connectors.field.twilioAccountSid': 'Идентификатор аккаунта',
  'connectors.field.whatsappFrom': 'Отправитель WhatsApp',
  'connectors.field.whatsappFromHint': 'В международном формате, начиная со знака плюс.',
  'connectors.field.twilioAuthToken': 'Токен авторизации',
  'connectors.problem.smtp': 'Заполните сервер, порт, имя сервера TLS, адрес отправителя, логин и пароль.',
  'connectors.problem.smtpPort': 'Порт должен быть целым числом от 1 до 65535.',
  'connectors.problem.telegram': 'Введите токен бота.',
  'connectors.problem.twilio': 'Заполните идентификатор аккаунта, отправителя WhatsApp и токен авторизации.',
  'connectors.problem.whatsappFrom': 'Отправитель WhatsApp должен быть международным номером, начинающимся со знака плюс.',

  'connectors.error.revisionConflict':
    'Кто-то другой изменил этот коннектор, пока панель была открыта. Перезагрузите его, чтобы увидеть текущую редакцию; введённые значения остаются.',
  'connectors.error.duplicateIdentity': 'Коннектор с такой идентичностью уже существует. Откройте существующий.',
  'connectors.error.purposeConflict':
    'Другой коннектор уже обслуживает это назначение и аудиторию. Выберите другое назначение или сначала переназначьте другой коннектор.',
  'connectors.error.identityMismatch':
    'Эти учётные данные принадлежат другому боту или отправителю. Замена учётных данных не может изменить идентичность коннектора; создайте новый коннектор.',
  'connectors.error.notConfigured': 'У коннектора нет учётных данных, поэтому включить его нельзя. Сначала сохраните учётные данные.',
  'connectors.error.migrationUnresolved': 'Миграция этой записи не завершена. Удалите её учётные данные, чтобы вывести запись из использования.',
  'connectors.error.invalid': 'Провайдер или сервер отклонили эти поля. Проверьте их и попробуйте снова; введённые значения остаются.',
  'connectors.error.notFound': 'Этого коннектора больше нет на сервере.',
  'connectors.error.forbidden': 'Вам не разрешено изменять коннекторы.',
  'connectors.error.unavailable': 'Сервер недоступен. Введённые значения остаются.',
  'connectors.error.conflict': 'Сервер отклонил это изменение из-за конфликта. Перезагрузите коннектор и попробуйте снова.',
  'connectors.error.unknown': 'Сервер вернул неожиданный ответ. Введённые значения остаются.',
}
